/** Routes accessible without authentication */
export const PUBLIC_PATHS = ["/login", "/register", "/auth/reset-password"]
